<div class="cart-items" directive-scroll (onScrollInit)="handleScrollInit($event)" (onScrollY)="handleScrollY($event)"
    directive-max-on-screen-height="target" [maxHeight]="maxHeight" registerId="cart-popup" #container>
    <div class="cart-items__inner" #itemsList>

        <ng-container *ngFor="let cartItem of cartItems;trackBy: trackBy;">
            <div directive-max-on-screen-height="item" registerId="cart-popup"
                [subRegisterId]="'cart-item-'+cartItem._Id" class="cart-items__item">
                <shared-tile-for-cart [cartItem]="cartItem" class="cart-items__tile"></shared-tile-for-cart>
            </div>
        </ng-container>


    </div>
</div>